/* import __COLOCATED_TEMPLATE__ from './confirm-square-one-pricing.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { DateTime } from '@square/dashboard-protos/models/squareup/common/time';
export let SquareOnePricingDeviceType = /*#__PURE__*/function (SquareOnePricingDeviceType) {
  SquareOnePricingDeviceType["KIOSK"] = "kiosk";
  SquareOnePricingDeviceType["KDS"] = "kds";
  return SquareOnePricingDeviceType;
}({});
let ConfirmSquareOnePricing = (_class = class ConfirmSquareOnePricing extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
  }
  get isRemoving() {
    if (!this.squareOnePricing) {
      return false;
    }
    // see if we are adding or subtracting
    return this.squareOnePricing.currentCost.amount > this.squareOnePricing.newCost.amount;
  }
  get translations() {
    const baseTranslations = {
      perMonth: unitPrice => this.intl.t('sharedUi.confirmSquareOnePricing.perMonth', {
        unitPrice: this.formatter.formatMoney(unitPrice)
      }),
      current: this.intl.t('sharedUi.confirmSquareOnePricing.current'),
      total: this.intl.t('sharedUi.confirmSquareOnePricing.total'),
      preTax: this.intl.t('sharedUi.confirmSquareOnePricing.preTax'),
      button: this.intl.t('sharedUi.confirmSquareOnePricing.button')
    };
    if (this.isRemoving) {
      return {
        ...baseTranslations,
        unit: this.intl.t('sharedUi.confirmSquareOnePricing.remove.unit'),
        billing: this.squareOnePricing.billingDate ? this.intl.t('sharedUi.confirmSquareOnePricing.remove.billing', {
          billingDate: this.intl.formatDate(this.squareOnePricing.billingDate.instantUsec / 1000, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })
        }) : '',
        currentCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.currentCost),
        unitPricePerMonth: baseTranslations.perMonth(this.squareOnePricing.unitPrice),
        newCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.newCost)
      };
    } else {
      return {
        ...baseTranslations,
        unit: this.intl.t('sharedUi.confirmSquareOnePricing.add.unit'),
        billing: this.squareOnePricing.billingDate ? this.intl.t('sharedUi.confirmSquareOnePricing.remove.billing', {
          billingDate: this.intl.formatDate(this.squareOnePricing.billingDate.instantUsec / 1000, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })
        }) : '',
        currentCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.currentCost),
        unitPricePerMonth: baseTranslations.perMonth(this.squareOnePricing.unitPrice),
        newCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.newCost)
      };
    }
  }
  get squareOnePricing() {
    const {
      nextFeeDate,
      currentCost,
      units,
      freeTrialEndAt
    } = this.args.squareOnePricingInfo;
    const device = this.args.deviceType === SquareOnePricingDeviceType.KIOSK ? units.kiosk : units.device;
    const MICROSECONDS_PER_MILLISECOND = 1000;
    let date = nextFeeDate?.instantUsec ? new Date(nextFeeDate.instantUsec / MICROSECONDS_PER_MILLISECOND) : null;
    if (date === null && freeTrialEndAt) {
      date = new Date(freeTrialEndAt.instantUsec / MICROSECONDS_PER_MILLISECOND);
    }
    return {
      currentCost,
      newCost: device.add(currentCost),
      billingDate: date ? DateTime.create({
        instantUsec: date.getTime() * 1000,
        timezoneOffsetMin: date.getTimezoneOffset()
      }) : undefined,
      unitPrice: device.cost
    };
  }
  get modifiedUnitPrice() {
    if (!this.squareOnePricing) {
      return '';
    }
    // see if we are adding or subtracting
    const modifier = this.isRemoving ? '-' : '';
    return `${modifier}${this.squareOnePricing.unitPrice}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConfirmSquareOnePricing as default };